<span #anchor>{{ content }}</span>
<span class="k-icon k-i-arrow-chevron-up" (click)="show = !show" [title]="'errordialog.show.more' | translate"></span>
<kendo-popup
      [anchor]="anchor"
      (anchorViewportLeave)="show = false"
      *ngIf="show">
      <div class="content">
        <p class="title">
            {{ content }}
        </p>
        <p>
            {{ detailedContent }}
        </p>
      </div>
</kendo-popup>